import { MdHomeFilled } from "react-icons/md";
import { DefaultLayout } from "../../layouts";
import { PrivateMortgagesScreen, TitleSection } from "../../components";

export default function PrivateMortgages() {
  const breadCrumbs = [
    { title: <MdHomeFilled />, link: "/" },
    { title: "Services", link: "#" },
    { title: "Private Mortgages", link: "#" },
  ];

  return (
    <DefaultLayout>
      <TitleSection
        title="Services"
        bg="/images/private-mortgages-bg.png"
        breadCrumbs={breadCrumbs}
      />
      <PrivateMortgagesScreen />
    </DefaultLayout>
  );
}
